var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCataloguingAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03799 6.543L6.24599 4.3785C6.20699 4.2825 6.16649 4.1685 6.12449 4.0365C6.08249 3.9045 6.04049 3.762 5.99849 3.609C5.95949 3.762 5.91899 3.906 5.87699 4.041C5.83499 4.173 5.79449 4.2885 5.75549 4.3875L4.96799 6.543H7.03799ZM9.17549 9H8.23949C8.13449 9 8.04899 8.9745 7.98299 8.9235C7.91699 8.8695 7.86749 8.8035 7.83449 8.7255L7.34849 7.398H4.65299L4.16699 8.7255C4.14299 8.7945 4.09649 8.8575 4.02749 8.9145C3.95849 8.9715 3.87299 9 3.77099 9H2.82599L5.38649 2.493H6.61949L9.17549 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCataloguingAuto);
export default __webpack_public_path__ + "static/media/cataloguingAuto.34e41277d0c1aa52234f9a5bcf0b33df.svg";
export { ForwardRef as ReactComponent };